import { Link } from 'react-router-dom';

const ACADEMIES = [
  {
    title: 'Teacher Courses',
    audience: 'Pre-primary · Primary · Junior School · Senior School',
    courses: [
      'Mathematics', 'Biology', 'Chemistry', 'Physics', 'Agriculture', 'Home Science',
      'Health Science', 'Computer Science', 'Integrated Science', 'Environmental Science',
      'Drawing and Design', 'Aviation Technology', 'Building and Construction',
      'Electrical Technology', 'Metal Technology', 'Power Mechanics', 'Wood Technology',
      'Media Technology', 'Marine Technology', 'Engineering', 'Coding', 'Robotics',
      'Artificial Intelligence', 'STEM Integration',
    ],
  },
  {
    title: 'Teacher Trainer Academy',
    audience: 'Master trainers · TTC tutors · University lecturers · Curriculum developers',
    courses: [
      'Adult Learning Methodologies', 'Coaching and Mentoring', 'Facilitation Skills',
      'Training of Trainers', 'Digital Facilitation', 'Monitoring Teacher Professional Development',
      'Quality Assurance of Training', 'Developing Online Courses',
    ],
  },
  {
    title: 'School Leadership Academy',
    audience: 'Principals · Head teachers · Deputies · Academic masters · Heads of department',
    courses: [
      'Instructional Leadership', 'STEM School Improvement', 'Digital School Transformation',
      'Data-driven Decision Making', 'School Quality Assurance', 'Teacher Performance Management',
      'Resource Mobilization', 'Change Management', 'Competency-Based Curriculum Leadership',
    ],
  },
];

export function AcademyPage() {
  return (
    <div className="mx-auto max-w-5xl px-4 py-14">
      <h1 className="text-3xl font-bold text-ink-900">Professional Learning Academy</h1>
      <p className="mt-3 max-w-2xl text-ink-700">
        Continuous professional development designed for teachers, teacher trainers and school
        leaders implementing Competency-Based Education across Africa.
      </p>

      <div className="mt-8 grid gap-4 sm:grid-cols-2">
        <div className="card">
          <h2 className="text-base font-semibold text-ink-900">Free with any account</h2>
          <ul className="mt-2 space-y-1 text-sm text-ink-700">
            <li>· Introductory STEM courses</li>
            <li>· CBE orientation modules</li>
            <li>· Professional webinars</li>
            <li>· Demonstration lessons and sample assessments</li>
            <li>· Digital newsletters</li>
          </ul>
        </div>
        <div className="card border-brand-300">
          <h2 className="text-base font-semibold text-brand-900">Premium subscription</h2>
          <ul className="mt-2 space-y-1 text-sm text-ink-700">
            <li>· Two-week certification courses and CPD certificates</li>
            <li>· Leadership and trainer certification programmes</li>
            <li>· STEM instructional coaching</li>
            <li>· AI for Education, Coding, Robotics</li>
            <li>· Assessment for Learning · Inclusive STEM Education</li>
            <li>· Practical STEM pedagogy</li>
          </ul>
        </div>
      </div>

      <div className="mt-10 space-y-8">
        {ACADEMIES.map(academy => (
          <section key={academy.title}>
            <h2 className="text-xl font-semibold text-ink-900">{academy.title}</h2>
            <p className="text-sm text-ink-500">{academy.audience}</p>
            <div className="mt-3 flex flex-wrap gap-1.5">
              {academy.courses.map(course => (
                <span
                  key={course}
                  className="rounded-full bg-ink-100 px-3 py-1 text-xs text-ink-700"
                >
                  {course}
                </span>
              ))}
            </div>
          </section>
        ))}
      </div>

      <div className="mt-10 rounded-xl bg-brand-50 p-6">
        <h2 className="text-lg font-semibold text-brand-900">Teacher Resource Centre</h2>
        <p className="mt-1 text-sm text-ink-700">
          Sample lesson plans, teaching videos, guides, STEM activities and classroom posters are
          free. Complete lesson plans, schemes of work, interactive simulations, practical manuals,
          digital textbooks, assessment banks and AI-generated teaching resources come with premium
          membership.
        </p>
        <Link to="/membership" className="btn-primary mt-4">
          Compare membership
        </Link>
      </div>
    </div>
  );
}
